import {StylesConfig} from 'react-select'

export const colourStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    background: '#f5f8fa',
    border: 'none',
    margin: '0',
    padding: '0',
    boxShadow: 'none',
  }),
  singleValue: (styles) => ({
    ...styles,
    color: '#464E5F',
    border: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#B5B5C4',
  }),
  option: (styles) => ({
    ...styles,
    borderRadius: '5px',
  }),
}
